/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Button as ButtonAnt, ButtonProps } from 'antd';
import { lighten } from 'polished';
import { getCssVariableValue } from '@/utils/common';

export function Button(props: ButtonProps) {
  return (
    <ButtonAnt css={buttonStyle(props.type!)} {...props}>
      {props.children}
    </ButtonAnt>
  );
}

const buttonStyle = (type: string) => {
  const primaryColor = getCssVariableValue('--primary-color');
  const whiteColor = getCssVariableValue('--white-color');

  if (type === 'primary') {
    return css`
      background: ${primaryColor};
      border-color: ${primaryColor};
      color: ${whiteColor};
      align-items: center;
      &:hover {
        background: ${lighten(0.1, primaryColor)} !important;
        border-color: ${lighten(0.1, primaryColor)} !important;
      }
    `;
  } else if (type === 'text') {
    return css`
      padding: 0;
      height: auto;
      &:hover {
        padding: 0 !important;
        background: none !important;
      }
    `;
  } else {
    return css`
      background: none;
      border-color: ${primaryColor};
      color: ${primaryColor};
      align-items: center;
      &:hover {
        background: ${primaryColor} !important;
        border-color: ${lighten(0.1, primaryColor)} !important;
        color: ${whiteColor}!important;
      }
    `;
  }
};
